import toggleClass from 'utils/DOM/toggleClass'

function showZipCode() {
  const locationBlock = document.querySelector('.c-Form__section--location')
  const coverageBlock = document.querySelector('.c-Form__section--coverage')

  if (coverageBlock) {
    toggleClass(coverageBlock, 'c-Form__section--first', false)
  }

  if (locationBlock) {
    toggleClass(locationBlock, 'd-none', false)
    toggleClass(locationBlock, 'c-Form__section--first', true)
  }
}

export default showZipCode
